import Divider from "@material-ui/core/Divider";
import { FC } from "react";
import { FinanciamentoIndireto } from "src/components/pagamento/financiamentoIndireto/FinanciamentoIndireto";
import { FINANCIAMENTO } from "src/constants";
import { Formater, TypeRecords } from "src/framework/commons";
import { PedidoType, PessoasUploadsDocumento } from "src/types";

export interface DocumentosProperties {
    pedido: PedidoType | null;
    documentos: any[];
    pessoas?: PessoasUploadsDocumento;
    onChange: (value: any) => void;
}

const Documentos: FC<DocumentosProperties> = ({ pedido, documentos, pessoas, onChange }) => {
    return <>
        <div className="row">
            <div className="X12" style={{ padding: "10px" }}>
                <strong>Identificação:</strong> {`${Formater.toString(pessoas?.documento, TypeRecords.CPF_CNPJ)}${pessoas?.nome ? " - " + pessoas?.nome : ""}`}
            </div>
            <div className="X12" style={{ padding: "10px" }}>
                <Divider />
            </div>
            <div className="X12">
                <FinanciamentoIndireto 
                    validarArquivos
                    checkout={false}
                    formaPagamentoId={FINANCIAMENTO.id}
                    codigoVenda={pedido?.codigo_venda || ""}
                    cupomDesconto={pedido?.codigo_cupom || ""}
                    valorPedido={0}
                    pagamentoId={pedido?.pagamento_id || 0}
                    solo={false}
                    disabledConfirmar={true}
                    exibirBotoes={false}
                    documentosTeste={documentos || []}
                    onChangeValue={async (value: any) => {
                        if (value.documentos && value.documentos.length > 0) {
                            onChange(value);
                        }
                    }}
                    onConfirmar={(value: any) => {

                    }} />
            </div>
        </div>
    </>
}

export { Documentos };